import _slicedToArray from "/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import { styled } from '@creditas-ui/system';
import { getTypography, media, color } from '@creditas-ui/utilities';

var setVariantByBreakpoint = function setVariantByBreakpoint(variant, breakpoint, theme) {
  if (breakpoint === '_') {
    return getTypography(variant)({
      theme: theme
    });
  }

  return "\n    " + media.up(breakpoint) + " {\n      " + getTypography(variant)({
    theme: theme
  }) + "\n    }\n  ";
};

var getTypographyByBreakpoint = function getTypographyByBreakpoint(breakpointVariants, theme) {
  var breakpointVariantsList = Object.entries(breakpointVariants);
  return breakpointVariantsList.map(function (_ref) {
    var _ref3 = _slicedToArray(_ref, 2),
        breakpoint = _ref3[0],
        variant = _ref3[1];

    return setVariantByBreakpoint(variant, breakpoint, theme);
  });
};

var base = function base(_ref2) {
  var theme = _ref2.theme,
      variant = _ref2.variant;

  if (typeof variant === 'string') {
    return getTypography(variant)({
      theme: theme
    });
  }

  if (typeof variant === 'object') {
    return getTypographyByBreakpoint(variant, theme);
  }

  return '';
};

var TypographyElement = styled.p(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n"])), base, color);
export { TypographyElement };